import { useCallback } from 'react';
import type { List } from '@/modules/dashboard/dashboardTypes';
import { useToast } from '@/components/atoms/Toast';
import { useDispatch } from 'react-redux';
import {
	dashboardAddListFailure,
	dashboardAddListRequest
} from '@/modules/dashboard/dashboardActions';

export const useDuplicateListMutation = () => {
	const { toast } = useToast();
	const dispatch = useDispatch();

	const mutate = useCallback(
		(list: List) => {
			try {
				dispatch(dashboardAddListRequest(list));

				toast({
					title: `List ${list.name} duplicated`,
					variant: 'success'
				});
			} catch (error) {
				dispatch(dashboardAddListFailure(error as Error));

				toast({
					title: `Something went wrong with list ${list.name}`,
					variant: 'error'
				});
			}
		},
		[dispatch, toast]
	);

	return { mutate };
};
